/** @jsx jsx */
import { FC } from "react";
import { jsx } from "theme-ui";

import { TimeReportGuid } from "@/data/time-reports";
import { useTimeReportVersionsQuery } from "@/data/time-reports/queries/useTimeReportVersionsQuery";
import { TimeReportVersionsList } from "@/views/time-reports/versions";

interface TimeReportDetailsVersionsViewProps {
  timeReportGuid: TimeReportGuid;
}

export const TimeReportDetailsVersionsTab: FC<TimeReportDetailsVersionsViewProps> = ({ timeReportGuid }) => {
  const { data } = useTimeReportVersionsQuery(timeReportGuid);

  return <TimeReportVersionsList versions={data.content} />;
};
